/* =========================================================================
   Penny Premium 3D — product-form.js
   Buy-box behavior for sections/main-product.liquid:
   - Variant resolution from option pills/swatches (radio inputs), updating
     price / save-badge / availability / SKU / URL (?variant=) / hidden id
     — all inside fixed-height slots, zero layout shift.
   - Emits 'variant:changed' { variant } on the penny bus (gallery + sticky
     bar listen).
   - Quantity stepper.
   Add-to-cart submission itself is handled by cart.js (the form is a
   [data-quick-add-form]) — no duplicated cart logic here.

   Server-side data contract: <script type="application/json" data-product-json>
   with { variants: [{ id, available, options, sku, price, compare, save,
   media_id }] } — prices preformatted in Liquid, no client money math.
   ========================================================================= */

const penny = window.penny;

function initProductForm(root) {
  if (root.dataset.formReady) return;
  root.dataset.formReady = 'true';

  const data = JSON.parse(root.querySelector('[data-product-json]').textContent);
  const form = root.querySelector('[data-product-form]');
  const idInput = form?.querySelector('input[name="id"]');
  const fieldsets = Array.from(root.querySelectorAll('[data-option-fieldset]'));

  const priceEl = root.querySelector('[data-price-current]');
  const compareEl = root.querySelector('[data-price-compare]');
  const saveEl = root.querySelector('[data-price-save]');
  const skuEl = root.querySelector('[data-sku]');
  const atcButton = form?.querySelector('[data-atc-button]');
  const stickyPrice = document.querySelector('[data-sticky-price]');
  const stickyVariant = document.querySelector('[data-sticky-variant-text]');
  const stickyButton = document.querySelector('[data-sticky-atc-button]');
  const notify = root.querySelector('[data-notify]');

  const selectedOptions = () =>
    fieldsets.map((fs) => fs.querySelector('input:checked')?.value ?? null);

  const findVariant = (options) =>
    data.variants.find((v) => v.options.every((opt, i) => opt === options[i]));

  /* Mark option values that lead to no purchasable variant given the other
     current selections (strikethrough, still selectable so shoppers can
     pivot combinations). */
  const updateOptionStates = (options) => {
    fieldsets.forEach((fs, position) => {
      fs.querySelectorAll('input').forEach((input) => {
        const candidate = data.variants.find(
          (v) =>
            v.options[position] === input.value &&
            v.options.every((opt, j) => j === position || opt === options[j])
        );
        input.closest('[data-option-value]').classList.toggle(
          'is-unavailable',
          !candidate || !candidate.available
        );
      });
    });
  };

  const updateVariant = (variant) => {
    if (priceEl) priceEl.textContent = variant ? variant.price : '';
    if (compareEl) {
      compareEl.textContent = variant?.compare || '';
      compareEl.toggleAttribute('hidden', !variant?.compare);
    }
    if (saveEl) {
      saveEl.textContent = variant?.save || '';
      saveEl.toggleAttribute('hidden', !variant?.save);
    }
    if (skuEl) {
      skuEl.textContent = variant?.sku || '';
      skuEl.closest('[data-sku-row]')?.toggleAttribute('hidden', !variant?.sku);
    }
    if (stickyPrice && variant) stickyPrice.textContent = variant.price;
    if (stickyVariant) stickyVariant.textContent = variant ? variant.title : '';

    const purchasable = Boolean(variant?.available);
    if (atcButton) {
      atcButton.disabled = !purchasable;
      const label = atcButton.querySelector('[data-quick-add-label]');
      if (label) {
        label.textContent = !variant
          ? atcButton.dataset.labelUnavailable
          : purchasable
            ? atcButton.dataset.labelIdle
            : atcButton.dataset.labelSoldOut;
      }
    }
    if (stickyButton) stickyButton.disabled = !purchasable;
    notify?.toggleAttribute('hidden', purchasable || !variant);

    if (variant) {
      if (idInput) idInput.value = variant.id;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      penny.emit('variant:changed', { variant });
    }
  };

  root.addEventListener('change', (event) => {
    if (!event.target.closest('[data-option-fieldset]')) return;
    const options = selectedOptions();
    updateOptionStates(options);
    updateVariant(findVariant(options));
  });

  if (fieldsets.length > 0) updateOptionStates(selectedOptions());

  /* --- Quantity stepper --------------------------------------------------- */
  const qty = root.querySelector('[data-quantity-input]');
  root.querySelectorAll('[data-quantity-change]').forEach((button) => {
    button.addEventListener('click', () => {
      const delta = Number(button.dataset.quantityChange);
      qty.value = Math.max(1, Number(qty.value || 1) + delta);
      qty.classList.remove('tick-up', 'tick-down');
      void qty.offsetWidth;
      qty.classList.add(delta > 0 ? 'tick-up' : 'tick-down');
    });
  });

}

function initAll() {
  document.querySelectorAll('[data-product-root]').forEach(initProductForm);
}

initAll();
document.addEventListener('shopify:section:load', initAll);
